import hookAuth from '@/router/hooks/router.hook.auth'
import hookMe from '@/router/hooks/router.hook.me'
import hookMenu from '@/router/hooks/router.hook.menu'
import hookRole from '@/router/hooks/router.hook.role'

export default router => {
  router.beforeEach(hookAuth)
  router.beforeEach(hookMe)
  router.beforeEach(hookMenu)
  router.beforeEach(hookRole)

  return router
}
